import styled, { css } from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../jackpot-widget.component";

export interface IJackpotWidgetFooterBoxProps {
    layout: JACKPOT_WIDGET_LAYOUT;
};

export const JackpotWidgetFooterBox = styled.div<IJackpotWidgetFooterBoxProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;
	min-height: 1rem;

    ${({layout}) => (layout === JACKPOT_WIDGET_LAYOUT.PORTRAIT) && css`
	    flex-direction: column;
	    padding: 0rem 0rem 0.6rem;
		min-height: 4rem;
	`}

	${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE && css`
		flex-direction: column;
		justify-content: center;
		width: 35%;
		padding: 0 1rem 0 0;
	`}
`;
